import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/CustomerUserMessageBox.css";
const CustomerUserMessageBox = ({showCustomerUserMessageBox,setShowCustomerUserMessageBox,title,message}) =>{
    if(!showCustomerUserMessageBox) return null;
    return(
        <div className="customer-user-message-box-parent-container">
            <div className="customer-user-message-box-container">
                <div className="customer-user-message-box-header">
                    <p>{title}</p>
                    <p  className="customer-user-message-box-close-icon" 
                        onClick={() => setShowCustomerUserMessageBox(false)}>&#10006;</p>
                </div>
                <div className="customer-user-message-box-body">
                    <p>{message}</p>
                </div>
                <div className="customer-user-message-box-buttons-container">
                    <button onClick={() => setShowCustomerUserMessageBox(false)}>Okay</button>
                </div>
            </div>
        </div>
    );
};

export default CustomerUserMessageBox;